export const TIMEOUT= window._env_? window._env_.REACT_APP_TIMEOUT: 5000;
